export interface SalaryIndicationFields {
  salary_type: string | null;
  salary_min: number | null;
  salary_max: number | null;
  salary_fixed: number | null;
  salary_other: string | null;
}

function formatEuro(n: number | null): string {
  if (n === null) return "—";
  return `€${n.toLocaleString("nl-NL")}`;
}

export function formatSalaryIndication(v: SalaryIndicationFields): string {
  switch (v.salary_type) {
    case "range":
      return `${formatEuro(v.salary_min)} – ${formatEuro(v.salary_max)} / mnd`;
    case "fixed":
      return `${formatEuro(v.salary_fixed)} / mnd`;
    case "other":
      return v.salary_other?.trim() || "—";
    default:
      return "—";
  }
}
